import { block, cliCommand } from "common/api";

export function parseLinkStateResponse(response) {
  const attrs = [];
  const lines = response.split("\n");
  for (const line of lines) {
    const words = line.trim().split(/:\s+|\s{2,}/);

    for (let i = 0; i < words.length; i += 2) {
      if (words[i]) {
        attrs.push({ label: words[i], value: words[i + 1] });
      }
    }
  }

  const firstElement = attrs[0];
  attrs.splice(0, 1, { label: "Flags", value: firstElement.value });
  attrs.splice(0, 0, { label: "Name", value: firstElement.label });

  return attrs;
}

export function parseLinkStateDeviceResponse(response) {
  const attrs = [];
  const lines = response.split("\n");
  for (const line of lines) {
    const words = line.trim().split(/:(.*)/);

    for (let i = 0; i < words.length; i += 2) {
      if (words[i]) {
        attrs.push({ label: words[i], value: words[i + 1] });
      }
    }
  }
  return attrs;
}

const upOrDown = (value) =>
  value === "up" ? true : value === "down" ? false : undefined;

const yesOrNo = (value) =>
  value === "yes" ? true : value === "no" ? false : undefined;

const parseInterfaceLine = (line) => {
  const matchResult = line.match(/%ERR-ENOENT: Cannot get "(.*)" interface information/);
  if(matchResult){
    return {
      name: matchResult[1],
      type: 'n/a',
      mac: 'n/a',
      enabled: undefined,
      connected: undefined,
      management: false,
    };
  }
  const [name, type, mac, enabled, connected, management] = line.split(/\s+/);
  return {
    name,
    type,
    mac,
    enabled: upOrDown(enabled),
    connected: yesOrNo(connected),
    management: yesOrNo(management),
  };
};

export const parseInterfaces = (response) =>
  response.trim().split("\n").map(parseInterfaceLine);



const configureBlock = block({
  optional: true,
  start: "configure",
  end: "commit",
  enter: false,
});

export const updateCommand = (name, { enable = false, disable = true }) =>
  cliCommand`
    ${configureBlock([
      `interface ${name}`,
      enable ? "enabled" : disable ? "disabled" : "",
      "exit",
    ]).join("\n")}
  `(false /*enter*/);
